import React from 'react';
import { useEditorContext } from '@philips-internal/oswald-ui-core/lib/component/context/editor-context.js';
import { classNames, isDefined } from '@philips-internal/oswald-ui-utils';
import { getStepProperties } from '../../wizard-utils.js';
import { WizardSidebarGroup } from '../wizard-sidebar-group/wizard-sidebar-group.js';
import { WizardSidebarStep } from '../wizard-sidebar-step/wizard-sidebar-step.js';
import './wizard-sidebar.css';
function InnerWizardSidebarStep(props) {
    const { currentStepIdentifier, index, mode, readOnly: wizardReadOnly, step, stepsMetadata, stepsMetadataProps, parentGroupDisplayIndex } = props;
    const { properties, element } = step;
    const { title: propsTitle, subtitle: propsSubTitle } = element.props;
    const { done, enabled, identifier, readOnly: stepReadOnly } = getStepProperties(wizardReadOnly, mode, stepsMetadataProps, properties);
    const isCurrentStep = currentStepIdentifier === identifier;
    const isLastStep = stepsMetadata.length - 1 === index;
    const lastButOneIndex = stepsMetadata.length - 2;
    const isGroupStep = isDefined(parentGroupDisplayIndex);
    const showSeparator = isGroupStep ? !isLastStep : index <= lastButOneIndex;
    const readOnly = Boolean(stepReadOnly);
    return (React.createElement(WizardSidebarStep, { currentStep: isCurrentStep, displayIndex: props.index + 1, done: done, enabled: enabled, identifier: identifier, parentGroupDisplayIndex: parentGroupDisplayIndex, readOnly: readOnly, showSeparator: showSeparator, subtitle: propsSubTitle ?? '', title: propsTitle }));
}
function InnerWizardSidebarGroup(props) {
    const { currentStepIdentifier, group, groupsProps, index, mode, readOnly, stepsMetadata, stepsMetadataProps } = props;
    const { title } = group;
    const groupSteps = stepsMetadata.filter(step => group.children.some(groupStep => groupStep.props.identifier === step.properties.identifier));
    const groupStepsProperties = groupSteps.map((step) => getStepProperties(readOnly, mode, stepsMetadataProps, step.properties));
    const displayIndex = index + 1;
    const isCurrentGroup = group.children.some(step => step.props.identifier === currentStepIdentifier);
    const isGroupDone = groupStepsProperties.every(step => step.done);
    const isGroupReadOnly = groupStepsProperties.every(step => step.readOnly);
    const lastButOneIndex = groupsProps.length - 2;
    const showSeparator = index <= lastButOneIndex;
    return (React.createElement(WizardSidebarGroup, { currentGroup: isCurrentGroup, displayIndex: displayIndex, done: isGroupDone, readOnly: isGroupReadOnly, showSeparator: showSeparator, title: title }, groupSteps.map((step, stepIndex) => React.createElement(InnerWizardSidebarStep, { currentStepIdentifier: currentStepIdentifier, index: stepIndex, key: step.properties.identifier, mode: mode, parentGroupDisplayIndex: displayIndex, readOnly: readOnly, step: step, stepsMetadata: groupSteps, stepsMetadataProps: stepsMetadataProps }))));
}
function renderVerticalSteps(props) {
    return props.stepsMetadata.map((step, index) => React.createElement(InnerWizardSidebarStep, { ...props, index: index, key: step.properties.identifier, step: step }));
}
function renderVerticalGroups(props) {
    const groupsProps = [...props.groupsPropsMap.values()];
    return groupsProps.map((group, index) => React.createElement(InnerWizardSidebarGroup, { ...props, group: group, groupsProps: groupsProps, index: index, key: group.identifier }));
}
function renderSidebarContent(props) {
    return props.groupsPropsMap.size > 0
        ? renderVerticalGroups(props)
        : renderVerticalSteps(props);
}
function WizardSidebar(props) {
    const editorContext = useEditorContext();
    if (!props.currentStepIdentifier && !editorContext?.isDesigning()) {
        return null;
    }
    const className = classNames({
        'c-wizard-sidebar': true,
        'c-wizard-sidebar--compact': Boolean(props.compact),
        'u-scrollbar': true,
    });
    return (React.createElement("div", { className: className }, renderSidebarContent(props)));
}
export { WizardSidebar, };
//# sourceMappingURL=wizard-sidebar.js.map